<template>
    <div class="mt-50">
      <div class="card border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <div class="text-center mb-10">
            <img src="../../../assets/images/fonta.png" alt="logo-icon" style="height: 100px;"/>
          </div>
          <h4 class="text-black fw-bold mb-0 text-center">
            Connectez-vous à votre compte !
          </h4>
          <Form ref="loginForm"  @submit="onSubmitLogin" :validation-schema="loginSchema">
            <div class="form-group mb-10 mb-sm-15 mb-md-17">
              <label class="d-block text-black fw-semibold mb-10">
                {{nomEmail}}
              </label>
              <Field name="email" v-model="email" type="text" :disabled="reponse"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer votre email"/>
                <ErrorMessage name="email" class="text-danger"/>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="d-flex align-items-center justify-content-between mb-10" >
              <label class="d-block text-black fw-semibold ">
                {{motDePasse}} 
              </label>
            </div>
            <Field name="password" v-model="password" type="password" class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer votre mot de passe"/>
                <ErrorMessage name="password" class="text-danger"/>
            </div>
            <button ref="submitButton"
              class="text-decoration-none text-center default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success  w-100"
              type="submit"  >
              Connectez-vous maintenant
            </button>
          </Form>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from "@/services/ApiService";
import { useRouter,useRoute } from 'vue-router';
import { useAuthStore } from '@/services/auth';
import Swal from 'sweetalert2';

export default defineComponent({
    name: "LoginForm",
    components: {
    Form,
    Field,
    ErrorMessage,
},
  setup: () => {
    const loginSchema = Yup.object().shape({
      email: Yup.string().required('L\'email   est obligatoire'),
      password: Yup.string().min(8, 'Le mot de passe doit contenir au moins 8 caractères').required('Le mot de passe est obligatoire'),
    });

    const router  = useRouter();
    const store = useAuthStore();
    const submitButton = ref<HTMLButtonElement | null>(null);
    const email = ref("");
    const password = ref("");
    const reponse = ref(false);
    const loginForm = ref(null);
    const route = useRoute();
    const onSubmitLogin = async (values: any) => {
      if(retour.value){
        if(retour.value.username){
          values["username"] = retour.value.username;
          values["email"] = retour.value.email;
        }
      }
      // Clear existing errors
      store.logout();
      if (submitButton.value) {
        submitButton.value.disabled = true;
      }
      // Send login request
       await store.login(values);
       const error = Object.values(store.errors);
      if (error.length === 0) {
          // Go to page after successfully login
          router.push({ name: "DashboardPage" });
      } else {
        Swal.fire({
          text: error[1] as string,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "OK",
          heightAuto: false,
          customClass: {
            confirmButton: "btn btn-sm fw-semobold btn-danger",
          },
        }).then(() => {
          store.errors = {};
        });
      }
      submitButton.value!.disabled = false;
    };
    const retour = ref<any>({});
    const recupereUtilisateur = async (username:string) =>{
      const element = {
        username:username
      };
      await ApiService.post("auth/getUtilisateur",element)
      .then(async ({ data }) => {
        if(data.data.length > 0){
          retour.value = {
            email: data.data[0].email,
            username: data.data[0].username,
            password: data.data[0].email
          }
          email.value = data.data[0].username;
          reponse.value = true
        return retour.value;
        }else{
          reponse.value = false
        }
       //
       
      })
      .catch(({ response }) => {
        //
      });
    }

    async function checkVariableChange(variable: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        const interval = setInterval(() => {
            if (variable) {
                clearInterval(interval);
                resolve(); // La variable a changé, résoudre la promesse
            }
        }, 1000); // Vérifiez toutes les 1 seconde

        // Au bout de 10 secondes, arrêtez de vérifier et rejetez la promesse si la variable n'a pas changé
        setTimeout(() => {
            clearInterval(interval);
            reject(new Error("La variable n'a pas changé dans le délai imparti."));
        }, 30000); // Attend 10 secondes au maximum
    });
}
const nomEmail = ref("Email");
const motDePasse = ref("Mot de passe")
    onMounted(async () => {
      if(route.query.email){
        nomEmail.value = "Pseudo";
        motDePasse.value = "Code";
        await recupereUtilisateur(route.query.email as string);
        await checkVariableChange(retour.value)
        // if(retour.value){
        //   await onSubmitLogin(retour.value)
        // }
      }
    });
   
    return { loginSchema,recupereUtilisateur,retour,password,reponse, email,motDePasse,nomEmail, onSubmitLogin, loginForm,submitButton};
  },
});
</script>